import React from 'react'
import { formatPhoneNumberIntl } from 'react-phone-number-input/input'

export function formatPhoneNumberForDisplay(phoneNumberString) {
  if (!phoneNumberString) {
    return ''
  }
  if (phoneNumberString.includes('+1')) {
    return formatPhoneNumberIntl(phoneNumberString)
  }
  return `+1 ${phoneNumberString}`
}

export function formatPhoneNumberForSave(phoneNumberString) {
  return phoneNumberString.replace('+1', '').replace(/\D/g, '')
}

//normalize phone to E.164 for use as react-phone-number-input value (e.g. "+15555555555")
export function formatPhoneNumberToE164(phoneNumberString) {
  if (!phoneNumberString) return ''
  const digits = phoneNumberString.replace(/\D/g, '')
  if (!digits.length) return ''
  if (digits.length === 11 && digits[0] === '1') return `+${digits}`
  if (digits.length >= 10) return `+1${digits.slice(-10)}`
  return `+1${digits}`
}

/** National US digit count after stripping country code / non-digits. */
export function usPhoneDigits(phoneNumberString) {
  if (!phoneNumberString) return ''
  let digits = String(phoneNumberString).replace(/\D/g, '')
  if (digits.length === 11 && digits[0] === '1') {
    digits = digits.slice(1)
  }
  return digits.slice(0, 10)
}

/**
 * Empty phone is allowed; a partially entered number is not.
 * @returns {boolean}
 */
export function isValidUsPhoneDigits(phoneNumberString) {
  const digits = usPhoneDigits(phoneNumberString)
  return digits.length === 0 || digits.length === 10
}

export default {
  formatPhoneNumberForDisplay,
  formatPhoneNumberForSave,
  formatPhoneNumberToE164,
  usPhoneDigits,
  isValidUsPhoneDigits,
}
